module.exports = __webpack_public_path__ + "img/weixinlogo.ef0392ba.png";